import { useLocation, useNavigate } from 'react-router-dom';
import logo from '../assets/Generallogo.png';

const Footer = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const handleScrollTo = (id) => {
        if (location.pathname !== '/') {
            navigate('/', { state: { scrollTo: id } });
            return;
        }
        const element = document.getElementById(id);
        if (element) {
            const offset = 80;
            const bodyRect = document.body.getBoundingClientRect().top;
            const elementRect = element.getBoundingClientRect().top;
            const offsetPosition = (elementRect - bodyRect) - offset;
            window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        }
    };

    const navLinks = [
        { id: 'home', label: 'HOME' },
        { id: 'about', label: 'ABOUT US' },
        { id: 'service', label: 'SERVICES' },
        { id: 'products', label: 'PRODUCTS' },
        { id: 'components', label: 'PROJECTS' },
        { id: 'contact', label: 'CONTACT' },
    ];

    return (
        <footer className="footer-architectural">
            <div className="footer-inner">

                {/* ── Main grid ── */}
                <div className="footer-grid">

                    {/* Brand */}
                    <div className="footer-brand-segment">
                        <div className="logo-glow-container">
                            <div className="logo-pulse-glow" />
                            <span className="footer-logo-text" style={{ 
                                fontWeight: '700', 
                                color: '#fff', 
                                letterSpacing: '4px',
                                fontSize: 'clamp(1.2rem, 5vw, 1.8rem)',
                                textTransform: 'uppercase',
                                fontFamily: 'Outfit, sans-serif',
                                display: 'block',
                                marginBottom: '5px'
                            }}>
                                AL WASEEQ DESIGN
                            </span>
                            <span className="footer-tagline" style={{
                                fontSize: '0.65rem',
                                color: '#fff',
                                letterSpacing: '3px',
                                fontWeight: '300',
                                textTransform: 'uppercase',
                                opacity: '0.5',
                                display: 'block'
                            }}>
                                We Craft Your Dream World
                            </span>
                        </div>
                        <p className="footer-description">
                            Architecting excellence with precision and vision. We transform conceptual
                            blueprints into structural landmarks that define modern horizons.
                        </p>
                    </div>

                    {/* Navigation */}
                    <div className="footer-nav-segment">
                        <h4 className="footer-heading">
                            <span className="heading-line" />
                            NAVIGATION
                        </h4>
                        <ul className="footer-links">
                            {navLinks.map(({ id, label }) => (
                                <li key={id}>
                                    <button onClick={() => handleScrollTo(id)}>{label}</button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* ── Bottom bar ── */}
                <div className="footer-bottom-bar">
                    <p className="copyright-text">
                        © {new Date().getFullYear()}&nbsp;
                        <span className="copyright-brand">AL-WASEEQ DESIGN</span>.
                        &nbsp;ALL RIGHTS RESERVED.
                    </p>
                    <a
                        href="https://safprotech.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="powered-by-segment"
                    >
                        <span className="powered-label">POWERED BY</span>
                        <span className="powered-brand">SAFPRO TECHNOLOGY SOLUTIONS</span>
                        <div className="powered-underline" />
                    </a>
                </div>
            </div>

            <style>{`
                /* ══ Base ══ */
                .footer-architectural {
                    background: #050505;
                    border-top: 1px solid rgba(197,160,89,0.1);
                    position: relative;
                    overflow: hidden;
                    z-index: 10;
                    font-family: 'Outfit', sans-serif;
                }

                .footer-inner {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: clamp(50px,8vw,100px) clamp(20px,5vw,60px) clamp(28px,4vw,44px);
                }

                /* ══ Main grid ══ */
                .footer-grid {
                    display: grid;
                    grid-template-columns: 1.6fr 1fr;
                    gap: clamp(40px,6vw,80px);
                    margin-bottom: clamp(40px,6vw,72px);
                }

                /* ══ Brand ══ */
                .logo-glow-container {
                    position: relative;
                    display: inline-block;
                    margin-bottom: clamp(16px,3vw,28px);
                }

                .logo-pulse-glow {
                    position: absolute;
                    top: 50%; left: 50%;
                    transform: translate(-50%,-50%);
                    width: 130%; height: 130%;
                    background: radial-gradient(circle, rgba(197,160,89,0.15) 0%, transparent 70%);
                    z-index: -1;
                    filter: blur(20px);
                    animation: pulseGlow 4s infinite alternate;
                }

                @keyframes pulseGlow {
                    from { opacity: 0.3; transform: translate(-50%,-50%) scale(0.8); }
                    to   { opacity: 0.8; transform: translate(-50%,-50%) scale(1.1); }
                }

                .footer-logo {
                    height: clamp(44px, 7vw, 62px);
                    filter: brightness(1.2);
                    display: block;
                    transition: transform 0.4s ease;
                }
                .footer-logo:hover { transform: scale(1.05); }

                .footer-description {
                    color: rgba(255,255,255,0.4);
                    font-size: clamp(0.8rem, 1.6vw, 0.95rem);
                    line-height: 1.95;
                    max-width: 440px;
                    font-weight: 300;
                    letter-spacing: 0.4px;
                    margin: 0;
                }

                /* ══ Navigation ══ */
                .footer-heading {
                    color: #fff;
                    font-size: clamp(0.65rem, 1.2vw, 0.78rem);
                    letter-spacing: 5px;
                    margin: 0 0 clamp(24px,4vw,40px) 0;
                    font-weight: 600;
                    text-transform: uppercase;
                    display: flex;
                    align-items: center;
                    gap: 14px;
                }

                .heading-line {
                    flex-shrink: 0;
                    width: 28px; height: 1px;
                    background: #C5A059;
                    display: block;
                }

                .footer-links {
                    list-style: none;
                    padding: 0; margin: 0;
                }

                .footer-links li {
                    margin-bottom: clamp(10px,2vw,18px);
                }

                .footer-links li button {
                    background: none;
                    border: none;
                    color: rgba(255,255,255,0.45);
                    font-size: clamp(0.68rem, 1.2vw, 0.8rem);
                    letter-spacing: 3px;
                    text-transform: uppercase;
                    padding: 0;
                    cursor: pointer;
                    position: relative;
                    transition: color 0.35s ease, transform 0.35s ease;
                    font-family: 'Outfit', sans-serif;
                }

                .footer-links li button::after {
                    content: '';
                    position: absolute;
                    bottom: -4px; left: 0;
                    width: 0; height: 1px;
                    background: #C5A059;
                    transition: width 0.35s ease;
                }

                .footer-links li button:hover {
                    color: #fff;
                    transform: translateX(8px);
                }
                .footer-links li button:hover::after { width: 100%; }

                /* ══ Bottom bar ══ */
                .footer-bottom-bar {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    gap: 16px;
                    padding-top: clamp(22px,3.5vw,36px);
                    border-top: 1px solid rgba(255,255,255,0.05);
                }

                .copyright-text {
                    color: rgba(255,255,255,0.3);
                    font-size: clamp(0.58rem, 1vw, 0.7rem);
                    letter-spacing: 1.5px;
                    font-weight: 300;
                    margin: 0;
                    white-space: nowrap;
                }

                .copyright-brand {
                    color: rgba(255,255,255,0.65);
                    font-weight: 500;
                }

                .powered-by-segment {
                    display: inline-flex;
                    flex-direction: column;
                    align-items: flex-end;
                    text-decoration: none;
                }

                .powered-label {
                    font-size: clamp(0.48rem, 0.9vw, 0.55rem);
                    color: #C5A059;
                    letter-spacing: 4px;
                    margin-bottom: 4px;
                    opacity: 0.7;
                }

                .powered-brand {
                    font-size: clamp(0.6rem, 1.1vw, 0.72rem);
                    color: rgba(255,255,255,0.45);
                    letter-spacing: 2px;
                    font-weight: 400;
                    transition: color 0.3s ease;
                    white-space: nowrap;
                }

                .powered-underline {
                    width: 0; height: 1px;
                    background: #C5A059;
                    margin-top: 3px;
                    transition: width 0.3s ease;
                    align-self: flex-end;
                }

                .powered-by-segment:hover .powered-brand  { color: #fff; }
                .powered-by-segment:hover .powered-underline { width: 100%; }

                /* ══ Tablet  ══ */
                @media (max-width: 768px) {
                    .footer-grid {
                        grid-template-columns: 1fr;
                        gap: clamp(32px,5vw,50px);
                        text-align: center;
                    }

                    .logo-glow-container { margin-left: auto; margin-right: auto; }
                    .footer-description  { margin: 0 auto; max-width: 480px; }

                    .footer-heading { justify-content: center; }

                    /* Nav links — switch to horizontal wrap on tablet */
                    .footer-links {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: center;
                        gap: 8px 28px;
                    }
                    .footer-links li { margin-bottom: 0; }
                    .footer-links li button:hover { transform: translateY(-2px); }

                    /* Bottom bar — stack vertically and center */
                    .footer-bottom-bar {
                        flex-direction: column;
                        align-items: center;
                        gap: 14px;
                        text-align: center;
                    }
                    .powered-by-segment { align-items: center; }
                    .powered-underline  { align-self: center; }
                }

                /* ══ Mobile ══ */
                @media (max-width: 480px) {
                    .footer-inner {
                        padding-left: 18px;
                        padding-right: 18px;
                    }
                    .footer-grid { gap: 28px; }
                    .footer-description { font-size: 0.8rem; line-height: 1.75; }
                    .footer-heading { font-size: 0.65rem; letter-spacing: 4px; margin-bottom: 18px; }
                    .footer-links  { gap: 6px 20px; }
                    .footer-links li button { font-size: 0.65rem; letter-spacing: 2px; }
                    .copyright-text { font-size: 0.56rem; letter-spacing: 1px; white-space: normal; text-align: center; }
                    .powered-brand  { font-size: 0.58rem; letter-spacing: 1.5px; white-space: normal; text-align: center; }
                }
            `}</style>
        </footer>
    );
};

export default Footer;

